<template>
  <div class="agreement_page">
    <div class="agreement_title">{{info.title}}</div>
    <div class="agreement_content" v-html="info.content"></div>
</div>
</template>

<script>
    import common from '../../api/common';
    import content from '../../api/content';
    import { mapState } from 'vuex';
    export default {
      data () {
        return {
            info:''
        }
    },
    computed: {
      ...mapState({
        user: state => state.param.user,
        source: state => state.param.source
    })
  },
  created () {
    this.$store.commit('param/show', false)
    this.$appService.isShowReturn({state: true})
   
    var apppar={
        title:this.$route.meta.title
    }
    this.$appService.changeTitle(apppar)
    let source = this.$store.state.param.source
    this.getAgreement(14)
},
methods: {
    getAgreement(id){
        content.getAgreement({id:id}).then(res => {
          this.info=res.data.data
      })
    },
}
};
</script>

<style lang="scss">
    .agreement_page {
      padding: 10px;
  }
</style>
